import { Inject, Pipe, PipeTransform } from "@angular/core";
import { DATA_PATH_SERVICE } from "../services/upgraded-provider/upgraded-providers";

interface ExtraData {
    elementName: string;
    pathKeys: any[];
    isTransient: boolean;
}

interface NodeData {
    paths: {
        dataJsonPath: string
    }
}

/**
 * Pipe utilizado para gerar de identificador.
 */
@Pipe({
    name: "nodeIdentifier"
})
export class NodeIdentifierPipe implements PipeTransform {

    constructor(@Inject(DATA_PATH_SERVICE) private readonly dataPathService) { }

    transform(node: NodeData, { elementName, pathKeys, isTransient }: ExtraData): string {
        let path = node.paths.dataJsonPath;

        if (!isTransient && pathKeys?.length > 0) {
            path = this.dataPathService.getNodePath(pathKeys, node);
        }

        return `${path}_${elementName}`;
    }

}
